<div class="modal-header">
    <h4 class="modal-title">Criar Nova Campanha</h4>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>

<div class="modal-body p-0">
    <div class="row g-0">
        <!-- Sidebar de Etapas -->
        <div class="col-md-3 border-end bg-light-subtle">
            <div class="h-100">
                <ul class="nav nav-pills flex-column nav-fill mt-5">
                    <li class="nav-item">
                        <a class="nav-link text-start d-flex align-items-center"
                           [class.active]="currentStep() === 1"
                           [class.link-success]="currentStep() > 1"
                           (click)="goToStep(1)">
                            @if (currentStep() > 1) {
                                <i class="ti ti-check me-2"></i>
                            } @else {
                                <span class="step-number">1</span>
                            }
                            <span>Informações</span>
                        </a>
                    </li>
                    <li class="nav-item mt-2">
                        <a class="nav-link text-start d-flex align-items-center"
                           [class.active]="currentStep() === 2"
                           [class.disabled]="!canGoToStep(2)"
                           (click)="goToStep(2)">
                             @if (currentStep() > 2) {
                                <i class="ti ti-check me-2"></i>
                            } @else {
                                <span class="step-number">2</span>
                            }
                            <span>Preview e Confirmação</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Conteúdo da Etapa -->
        <div class="col-md-9">
            <div class="p-4 h-100">
                <div class="step-content-wrapper">
                    @switch (currentStep()) {
                    @case (1) {
                        <app-step-1-basic-info
                            [filters]="filters"
                            [campaignData]="campaignData()"
                            (dataChange)="updateCampaignData($event)"
                            (validityChange)="updateStep1Validity($event)"
                        />
                    }
                    @case (2) {
                        <app-step-2-preview
                            [filters]="filters"
                            [previewData]="previewData()"
                            [campaignData]="campaignData()"
                            (dataChange)="updatePreviewData($event)"
                            (campaignDataChange)="updateCampaignData($event)"
                            (validityChange)="updateStep2Validity($event)"
                        />
                    }
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer border-0">
    <div class="d-flex justify-content-between w-100">
        <div>
            @if (currentStep() > 1) {
                <button type="button" class="btn btn-light" (click)="previousStep()" [disabled]="isCreating()">
                    <i class="ti ti-arrow-left me-2"></i>
                    Voltar
                </button>
            }
        </div>

        <div class="d-flex gap-2">
            <button type="button" class="btn btn-light" (click)="close()" [disabled]="isCreating()">
                Cancelar
            </button>

            @if (currentStep() < 2) {
                <button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="currentStep() === 1 && !isStep1Valid()">
                    Próximo
                    <i class="ti ti-arrow-right ms-2"></i>
                </button>
            } @else {
                <button type="button" class="btn btn-success" (click)="createCampaign()" [disabled]="isCreating() || !isStep2Valid()">
                    @if (isCreating()) {
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Criando...
                    } @else {
                        <i class="ti ti-check me-2"></i>
                        Criar Campanha
                    }
                </button>
            }
        </div>
    </div>
</div>
